<template lang="pug">
.px-4
  v-progress-circular(
    v-if="loading"
    indeterminate
    color="primary"
  )
  v-expansion-panels(v-else)
    v-expansion-panel(v-for="item in users")
      v-expansion-panel-header
        .d-flex
          v-icon.mr-4(color="primary") mdi-account
          div
            .text-body-1 {{ item.full_name }}
            .caption Группа {{ item.record.group.short_name }}
      v-expansion-panel-content
        v-list(height="400").overflow-auto
          v-list-item(
            v-for="attr in item.attributes"
            :key="attr.id"
            :href="attr.value && attr.value.url"
            target="_blank"
          )
            v-list-item-content
              v-list-item-title {{ attr.name }}
              v-list-item-subtitle(v-if="attr.value")
                template(v-if="attr.type === $conf.INPUT_TYPES.calendar")
                  | {{ attr.value | dp('d.MM.yyyy') }}
                template(v-else-if="attr.type === $conf.INPUT_TYPES.file")
                  | {{ attr.value.url }}
                template(v-else)
                  | {{ attr.value }}
              v-list-item-subtitle(v-else) Не указано

  .d-flex.py-4
    v-spacer
    v-btn.mr-4(
      depressed
      @click="$emit('close')"
    ) Отмена
    v-btn(
      depressed
      color="success"
      @click="$emit('success')"
    ) Зачислить
</template>
<script>
export default {
  props: {
    duplicates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      users: [],
      loading: true,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const duplicatesByRecord = this.duplicates.reduce((acc, cur) => {
        if (!acc[cur.prior_record_id]) {
          acc[cur.prior_record_id] = [];
        }
        acc[cur.prior_record_id].push(cur.user_id);
        return acc;
      }, {});

      const promises = Object.entries(duplicatesByRecord).map(
        ([recordId, ids]) => this.$api.enrollments.enrollmentUsers(recordId, { expand: 'attributes', 'search[id]': ids }),
      );
      const result = await Promise.all(promises);
      this.users = result.flatMap(({ items }) => items);
      this.loading = false;
    },
  },
};
</script>
